'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import z from 'zod';
import { Admonition, admonitionSchema } from './admonition';

export const Tip = (props: z.input<typeof admonitionSchema>) => {
  const t = useTranslations();
  const { children } = props;

  return (
    <Admonition severity="success" title={t('mdx:alert:tip')}>
      {children}
    </Admonition>
  );
};

export default Tip;
